import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { BaseFormComponent } from '../../../../shared/base/base-form.component';
import { Constants } from '../../../../app.constants';
import { AuthService } from 'src/app/core/auth.service';
import { LoadingService } from 'src/app/core/loading.service';
import { TranslatorService } from 'src/app/core/translator.service';
import { UtilityService } from 'src/app/core/utility.service';
import { DialogService } from 'src/app/core/dialog.service';
import { AlertService } from 'src/app/core/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '../../../../shared/base/base.service';
import { Privilege, Role } from '../roles.models';

import DataSource from "devextreme/data/data_source";
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';

@Component({
  templateUrl: './roles-form.component.html'
})
export class RolesFormComponent extends BaseFormComponent implements OnInit {
  @ViewChild('table') table: DxDataGridComponent;
  // public privileges: DataSource;
  public privileges: any[] = [];
  public selectedPrivileges: any[] = [];
  public allPrivileges: any[] = [];
  public roles: DataSource;
  public allRolesGrouped: any[] = [];
  public groups: string[] = [];
  public unclassified: string;
  public undeletablePrivileges: any[] = [];

  public tabs: string[] = ['PRIVILEGES'];

  public parentFlag: boolean = false;

  constructor(
    private translateService: TranslateService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    public baseService: BaseService,
    protected dialogService: DialogService,
    
    protected router: Router,
    protected alertService: AlertService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService);
  }

  ngOnInit() {
    this.authorities.init('CUD_RL', 'R_RL', 'CUD_RL', 'CUD_RL');

    this.unclassified = this.translateService.instant('ROLES.UNCLASSIFIED');

    this.url = `${Constants.contextPath}/roles`;

    this.prepareLookupData();
    this.prepareFormData(null, (result: any) => {
      if (result.privileges) {
        this.selectedPrivileges = result.privileges;
      }

      if (result.undeletablePrivileges) {
        for (let up of result.undeletablePrivileges) {
          let item = this.allPrivileges.find(p => p.id == up);
          if (item)
            this.undeletablePrivileges.push(item);
        }
      }

      result.breadcrumbsId = result.value;
      return result;
    });
  }

  prepareLookupData() {
    if (this.authService.hasAuthority('R_PR'))
      this.baseService.getAll(`${Constants.contextPath}/privileges`, (response: {content: Privilege[]}) => {
        this.allPrivileges = response.content;
        this.privileges = this.allPrivileges;
      });

    if (this.authService.hasAuthority('R_RL'))
      this.roles = this.prepDataSource();

    // if(this.authService.hasAuthority('R_RR')) 
    //     this.baseService.getAllAsPromise(`${Constants.contextPath}/roles${this.id == null ? '' : '/eligible-for-parent/' + this.id}`, 0, '', '&sortBy=value&sortOrder=asc', (response: Role[]) => {
    //         this.allRolesGrouped = this.prepareGroups(this.extractValues(response));
    //         this.roles = this.prepareDataSource(this.allRolesGrouped);
    //         for(let item of this.allRolesGrouped)
    //             if(item.type != null)
    //                 this.groups.push(item.type);

    //     }, null, 1000);
  }

  // After parent role changes
  public updatePrivileges = ($event: any) => {
    if ((this.formData.parent != null && this.parentFlag) || (this.formData.parent == null)) {
      if ($event.selectedItem != null) {
        this.privileges = null;
        this.selectedPrivileges = [];
        if ($event.selectedItem.privileges != null && $event.selectedItem.privileges.length > 0) {
          let updatedPrivileges = [];
          $event.selectedItem.privileges.forEach(p => {
            updatedPrivileges.push(this.allPrivileges.find(ap => ap.value === p));
          });

          this.privileges = updatedPrivileges;
        }

      } else {
        this.privileges = this.allPrivileges;
      }
    } else if (this.formData.parent != null && !this.parentFlag) {
      if ($event.selectedItem != null && $event.selectedItem.privileges != null) {
        let updatedPrivileges = [];
        $event.selectedItem.privileges.forEach(p => {
          updatedPrivileges.push(this.allPrivileges.find(ap => ap.value === p));
        });

        this.privileges = updatedPrivileges;
      } else {
        this.privileges = this.allPrivileges;
      }
      this.parentFlag = true;
    }
    if($event.selectedItem)
      if((!this.initialFormData.parent) || (this.initialFormData.parent && $event.selectedItem.id != this.initialFormData.parent))
        this.pendingChanges = true;
  }

  public onSelectionChanged(event) {
    if (event != null) {
      if (event.currentDeselectedRowKeys != null) {
        for (let key of event.currentDeselectedRowKeys) {
          if (this.undeletablePrivileges.find(up => up.value == key)) {
            this.selectedPrivileges.push(key);
            this.table.instance.selectRows([key], true);
          }
        }
      }
      if(event.currentSelectedRowKeys.length == 1)
        this.pendingChanges = true;
    }
  }

  onCellPrepared($event: any) {
    if ($event.rowType == "data" && $event.data != null) {
      if (this.undeletablePrivileges.find(up => up.id == $event.data.id))
        $event.cellElement.className += " disabled-selection";
    }
  }

  private extractValues(list) {
    if (Array.isArray(list)) {
      for (let item of list)
        item.description = `${item.value}: ${item.description}`;
      return list;
    } else {
      list.description = `${list.value}: ${list.description}`;
      return list;
    }

  }

  private prepareGroups(list: any[]) {
    for (let item of list)
      if (item.groups == null)
        item.groups = this.unclassified;
    let groups = [...new Set(list.map(item => item.groups))];
    let resultList = [];
    for (let group of groups) {
      resultList.push({
        type: group,
        collection: list.filter(item => item.groups == group)
      });
    }
    return resultList;
  }

  private prepDataSource() {
    return new DataSource({
      key: 'id',
      group: 'groups',
      store: new CustomStore({
        load: () => {
          return this.baseService.getAllAsPromise(`${Constants.contextPath}/roles${this.id == null ? '/list' : '/eligible-for-parent/' + this.id}`, 0, '', '&sortBy=value&sortOrder=asc', (result) => {
            
            let response = result.content ? result.content : result;

            this.allRolesGrouped = this.prepareGroups(this.extractValues(response));
            this.roles = this.prepareDataSource(this.allRolesGrouped);
            for (let item of this.allRolesGrouped)
              if (item.type != null)
                this.groups.push(item.type);

          }, null, 1000);
        },
        loadMode: 'raw'
      })
    });
  }

  private prepareDataSource(list: { type: string, collection: any }[]) {
    return new DataSource({
      store: list,
      map: function (item) {
        return {
          key: item.type,
          items: item.collection
        }
      }
    });
  }

  public addNewGroup = (e: any) => {
    if (!e.text) {
      e.customItem = null;
      return;
    }
    this.groups.push(e.text);

    e.customItem = e.text;
  };

  public saveChanges(): void {


    this.formData.privileges = this.selectedPrivileges;

    if (!this.isFormValid())
      return;

    if (this.id == null)
      this.baseService.create(this.url, this.formData, () => {
        this.onSaveSuccess();
      });
    else
      this.baseService.update(this.url, this.formData, () => {
        this.onSaveSuccess();
      });
  }
}
